class DelayNode extends Weaver.Node

  @className = 'Delay'

  constructor: (id) ->
    super(id)

  create: (name = "New Delay", delayTime = 0.5, maxDelayTime = 2) ->
    type = await Weaver.Node.firstOrCreate('Delay')
    @set('name', name)
    @set('delayTime', delayTime)
    @set('maxDelayTime', maxDelayTime)
    @relation('type').add(type)
    @save()

export default DelayNode
